<div class="language-dialog">
  <div class="language-option clickable" *ngFor="let option of languageOptions" (click)="changeLang(option.key)">
    {{option.label}}
  </div>
</div>